// CG accessibility audit + re-audit remediation: January & July 2026 (a11y.js)

// Accessibility fixes NOT in chronological order. To find a particular fix listed in the audit spreadsheet, type in the displayed number in your editor's search box 

(function() {
    /* ==========================================================================
    = Farmers Organic Sourcing Accessibility Fixes 
    ========================================================================== */

    /* = Fix 187: Remove tabindex and role attributes from Slick Slider
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const slider = document.querySelector('.tlp-slider__slick');
        if (!slider) return;

        const waitForSlick = setInterval(() => {
            if (slider.classList.contains('slick-initialized')) {
                console.log('Slick is now initialized');

                slider.querySelectorAll('.slick-slide, .slick-cloned').forEach(slide => {
                    slide.removeAttribute('tabindex');
                    slide.removeAttribute('role');
                });

                $(slider).on('afterChange reInit', () => {
                    slider.querySelectorAll('.slick-slide, .slick-cloned').forEach(slide => {
                        slide.removeAttribute('tabindex');
                        slide.removeAttribute('role');
                    });
                });

                clearInterval(waitForSlick);
            }
        }, 100);
    });

    /* = Fix 189: Aria-labels for Slick Slider controls
    -------------------------------------------------------------- */

    if (window.location.pathname === '/pages/farmers-organic-sourcing') {
        document.addEventListener('DOMContentLoaded', () => {
            const fixArrows = () => {
                document.querySelectorAll('.slick-prev').forEach(btn => {
                btn.setAttribute('aria-label', 'Previous slide');
                    btn.querySelectorAll('svg').forEach(svg => {
                        svg.setAttribute('aria-hidden', 'true');
                        svg.setAttribute('focusable', 'false');
                    });
                });

                document.querySelectorAll('.slick-next').forEach(btn => {
                    btn.setAttribute('aria-label', 'Next slide');
                    btn.querySelectorAll('svg').forEach(svg => {
                        svg.setAttribute('aria-hidden', 'true');
                        svg.setAttribute('focusable', 'false');
                    });
                });
            };

            fixArrows();

            new MutationObserver(() => {
                fixArrows();
            }).observe(document.body, { childList: true, subtree: true });
        });
    }

    /* = Fix 190: Remove keyboard focus from video control when not visible
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
            if (m.attributeName === 'data-open') {
                const modal = m.target;
                const isOpen = modal.getAttribute('data-open') === 'true';
                modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            }
            });
        });

        document.querySelectorAll('.tlp-slider__video-modal').forEach(modal => {
            modal.setAttribute('aria-hidden', 'true');
            observer.observe(modal, { attributes: true });
        });
    });

    if (window.location.pathname === '/pages/farmers-organic-sourcing') {

        /* = Fix 191: Move focus to tabpanel after tab button selection
        -------------------------------------------------------------- */

        document.addEventListener('DOMContentLoaded', () => {
            const tabs = Array.from(document.querySelectorAll('[role="tab"]'));

            tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                const id = tab.getAttribute('aria-controls');
                const panel = document.getElementById(id);

                tabs.forEach(t => {
                    t.setAttribute('aria-selected', 'false');
                    t.setAttribute('tabindex', '-1');
                });

                tab.setAttribute('aria-selected', 'true');
                tab.setAttribute('tabindex', '0');

                document.querySelectorAll('[role="tabpanel"]').forEach(p => {
                    p.hidden = true;
                });

                panel.hidden = false;
                panel.focus();
                });
            });

            tabs.forEach(tab => {
                tab.addEventListener('keydown', e => {
                const i = tabs.indexOf(tab);

                if (e.key === 'ArrowRight') {
                    const next = tabs[i + 1] || tabs[0];
                    next.focus();
                }

                if (e.key === 'ArrowLeft') {
                    const prev = tabs[i - 1] || tabs[tabs.length - 1];
                    prev.focus();
                }
                });
            });
        });

        /* = Fix 194: Remove keyboard focus on hidden navigation menu links
        -------------------------------------------------------------- */

        const toggle = document.querySelector('.tlp-header__menu-btn'); 
        const links = document.querySelectorAll('.tlp-header__menu a'); 
        
        if (toggle && links.length) { 
            const update = () => { 
                const expanded = toggle.getAttribute('aria-expanded') === 'true'; 
                links.forEach(link => { 
                    if (expanded) { 
                        link.removeAttribute('tabindex'); 
                    } else { 
                        link.setAttribute('tabindex', '-1'); 
                    } 
                }); 
            }; 
            
            const observer = new MutationObserver(update); observer.observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] }); update(); 
        }
    }


    /* ==========================================================================
    = Header & Other Global Accessibility Fixes 
    ========================================================================== */

    /* = Fix 1: Skip link
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function() { 
        var skipLink = document.getElementById('skipLink'); 
        var target = document.getElementById('mainContainer'); 

        if (skipLink && target) { 
            skipLink.onclick = function(event) { 
                event.preventDefault(); 
                target.scrollIntoView(); 
                target.focus(); 
            }; 
        } 
    });

    /* = Fix 3: Keyboard functionality for mega-nav
    -------------------------------------------------------------- */

    function initNSSKeyboardHover() {
        const header = document.querySelector('nss-header');
        const topLinks = document.querySelectorAll('a.nss-link-nav[nss-mega-nav]');
        if (!header) return;

        let lastTrigger = null;

        function triggerHover(el) {
            el.dispatchEvent(new Event('mouseenter', { bubbles: true }));
        }

        function getSubNavButtons() {
            return Array.from(
            document.querySelectorAll('button.nss-mega-nav-products__button-d[nss-mega-sub-nav-id]')
            );
        }

        function focusFirstSubNavButton() {
            const buttons = getSubNavButtons();
            if (buttons.length) buttons[0].focus();
        }

        function focusFirstLearnCard() {
            const panel = document.querySelector('ul[nss-menu-id="learn"]');
            if (!panel) return;
            const card = panel.querySelector('a.nss-mega-nav-link-card');
            if (card) card.focus();
        }

        function focusFirstItemInPanel(id) {
            const panel = document.querySelector(`[nss-menu-id="${id}"]`);
            if (!panel) return;
            const focusable = panel.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
            if (focusable) focusable.focus();
        }

        function trapFocus(container) {
            const focusable = Array.from(
            container.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])')
            );
            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            function handleTrap(e) {
            if (e.key !== 'Tab') return;
                if (e.shiftKey) {
                    if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                    }
                } else {
                    if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                    }
                }
            }

            container.addEventListener('keydown', handleTrap);
        }

        function activateFocusTrapForShop() {
            const shop = document.querySelector('[nss-mega-nav-item-id="shop"]');
            if (shop) trapFocus(shop);
        }

        function activateFocusTrapForLearn() {
            const learn = document.querySelector('ul[nss-menu-id="learn"]');
            if (learn) trapFocus(learn);
        }

        function attachArrowKeyNavigation() {
            const buttons = getSubNavButtons();
            buttons.forEach((button, index) => {
                button.addEventListener('keydown', (event) => {
                    const key = event.key;
                    if (key === 'ArrowDown' || key === 'Down') {
                    event.preventDefault();
                    const next = buttons[index + 1] || buttons[0];
                    next.focus();
                    }
                    if (key === 'ArrowUp' || key === 'Up') {
                    event.preventDefault();
                    const prev = buttons[index - 1] || buttons[buttons.length - 1];
                    prev.focus();
                    }
                });
            });
        }

        topLinks.forEach((link) => {
            link.addEventListener('keydown', (event) => {
            const key = event.key;
            if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
                event.preventDefault();
                const id = link.getAttribute('nss-mega-nav');
                lastTrigger = link;
                triggerHover(link);
                link.click();
                if (id === 'learn') {
                setTimeout(() => {
                    focusFirstLearnCard();
                    activateFocusTrapForLearn();
                }, 60);
                } else {
                setTimeout(() => {
                    focusFirstSubNavButton();
                    attachArrowKeyNavigation();
                    activateFocusTrapForShop();
                }, 60);
                }
            }
            });
        });

        document.addEventListener('keydown', (event) => {
            const key = event.key;

            if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
            const active = document.activeElement;
                if (active && active.matches('button[nss-mega-sub-nav-id]')) {
                    event.preventDefault();
                    const id = active.getAttribute('nss-mega-sub-nav-id');
                    triggerHover(active);
                    active.click();
                    setTimeout(() => focusFirstItemInPanel(id), 60);
                }
            }

            if (key === 'Escape') {
            header.closeMegaNavEvent();
                if (lastTrigger) {
                    setTimeout(() => lastTrigger.focus(), 80);
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', initNSSKeyboardHover);
    document.addEventListener('shopify:section:load', initNSSKeyboardHover);

    /* = Fix 13: Focus trap for cart drawer
    -------------------------------------------------------------- */
    
    const html = document.documentElement; 
    const drawer = document.querySelector('nss-cart-drawer');

    function getFocusableElements() { 
        if (!drawer) return []; 
        return Array.from( drawer.querySelectorAll( 'a[href], button:not([disabled]), [role="button"], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])' ) ).filter(el => el.offsetParent !== null); 
    }
    
    function first() { 
        const focusables = getFocusableElements(); return focusables[0] || null; 
    } 
    
    function last() { 
        const focusables = getFocusableElements(); return focusables[focusables.length - 1] || null;
    } 
    
    function triggerClose() { 
        const closeBtn = drawer?.querySelector('button[nss-open-cart-drawer]');
        if (closeBtn) closeBtn.click(); 
    } 
    
    function updateOverlay() { 
        requestAnimationFrame(() => { 
            const ov = document.querySelector('nss-overlay'); 
            if (!ov) return; 
            const open = html.getAttribute('nss-cart-drawer-open') === 'true'; 
            ov.style.opacity = open ? '1' : '0'; 
            ov.style.pointerEvents = open ? 'all' : 'none'; 
        }); 
    } 
    
    function trap(e) { 
        if (e.key === 'Escape') { 
            html.setAttribute('nss-cart-drawer-open', 'false'); 
            triggerClose(); 
            return; 
        } 
        
        if (e.key !== 'Tab') return; 
        
        const f = first(); 
        const l = last(); 
        const a = document.activeElement; 
        
        if (!f || !l) return; 
        
        if (e.shiftKey && a === f) { 
            e.preventDefault(); 
            l.focus(); 
        } 
        
        else if (!e.shiftKey && a === l) { 
            e.preventDefault(); 
            f.focus(); 
        } 
    } 
    
    function activate(isOpening) { 
        const f = first(); 
        const l = last(); 
        if (!f || !l) return; 
        
        drawer.setAttribute('tabindex', '-1'); 
        drawer.focus(); 
        
        if (isOpening) { 
            setTimeout(() => f.focus(), 0); 
        }
        
        document.addEventListener('keydown', trap); 

        [f, l].forEach((el) => { 
            el.addEventListener('keydown', (e) => { 
                if (e.key === 'Enter' || e.key === ' ') { 
                    e.preventDefault(); 
                    html.setAttribute('nss-cart-drawer-open', 'false'); 
                    triggerClose(); 
                } 
            }); 
        }); 
        updateOverlay(); 
    } 
    
    function deactivate() { 
        document.removeEventListener('keydown', trap); 
        updateOverlay(); 
    } 
    
    let wasOpen = false; 
    
    new MutationObserver(() => { 
        const open = html.getAttribute('nss-cart-drawer-open') === 'true';

        if (open && !wasOpen) activate(true);
        else if (!open && wasOpen) deactivate();
        
        wasOpen = open; 
    }).observe(html, { attributes: true, attributeFilter: ['nss-cart-drawer-open'] });

    
    /* = Fix 17: Ensure aria-live region for cart updates
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const status = document.getElementById('cart-status-message');
        const anchor = document.getElementById('cart-focus-anchor');

        if (!status || !anchor) return;

        function getItemNameFromCart(button) {
            const title = button.closest('.nss-cart__item')?.querySelector('.nss-cart__item-title');
            return title ? title.textContent.trim() : 'Item';
        }

        function getItemNameFromRecommendation(button) {
            const title = button.closest('.nss-recommendations__card')?.querySelector('.nss-recommendations__card-text h2');
            return title ? title.textContent.trim() : 'Item';
        }

        document.addEventListener('click', (e) => {
            const target = e.target;

            if (target.closest('.nss-cart__items-wrapper')) { 
                document.activeElement.blur(); 
            }

            if (target.closest('.nss-link-small')?.textContent.trim() === 'Remove') {
                const name = getItemNameFromCart(target);
                status.textContent = `${name} removed from cart`;
                return;
            }

            if (target.closest('.nss-cart__item-qty-group > button:first-child')) {
                const group = target.closest('.nss-cart__item-qty-group');
                const input = group.querySelector('input');
                const name = getItemNameFromCart(target);

                if (input) {
                    const newQty = Math.max(0, Number(input.value) - 1);
                    status.textContent = newQty === 0
                    ? `${name} removed from cart`
                    : `${name} quantity decreased to ${newQty}`;
                }
                return;
            }

            if (target.closest('.nss-cart__item-qty-group > button:last-child')) {
                const group = target.closest('.nss-cart__item-qty-group');
                const input = group.querySelector('input');
                const name = getItemNameFromCart(target);

                if (input) {
                    const newQty = Number(input.value) + 1;
                    status.textContent = `${name} quantity increased to ${newQty}`;
                }
                return;
            }

            if (target.closest('.nss-recommendations__card-form-controls button[type="submit"]')) {
                const name = getItemNameFromRecommendation(target);
                status.textContent = `${name} added to cart`;
                return;
            }
        });
    });

    /* = Fixes 24 & 25: Klaviyo email field accessibility enhancements
    -------------------------------------------------------------- */

    function enhanceKlaviyoEmailField() {
        const container = document.querySelector('.klaviyo-form');
        if (!container) return;

        const emailInput = container.querySelector('input[type="email"]');
        if (!emailInput) return;

        emailInput.removeAttribute('aria-label');
        emailInput.id = 'klaviyo-email-field';

        if (!container.querySelector('label[for="klaviyo-email-field"]')) {
            const label = document.createElement('label');
            label.setAttribute('for', 'klaviyo-email-field');
            label.textContent = 'Email address';
            label.style.color = '#fff';
            label.style.fontSize = '18px';
            label.style.marginBottom = '10px';
            emailInput.parentNode.insertBefore(label, emailInput);
            emailInput.removeAttribute('placeholder');
        }

        const describedBy = emailInput.getAttribute('aria-describedby'); 
        if (!describedBy) return;

        const errorEl = document.getElementById(describedBy); 
        if (!errorEl) return;

        const text = errorEl.textContent.trim();
        if (!text) return;

        if (text === 'This field is required') { 
            errorEl.textContent = 'Please enter your email address.'; 
        }

        errorEl.removeAttribute('role'); 
        errorEl.removeAttribute('aria-live'); 
        errorEl.setAttribute('role', 'status');
    }

    const observer = new MutationObserver(enhanceKlaviyoEmailField);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', enhanceKlaviyoEmailField);

    /* = Re-audit fix 92 (July 2026): Added tabindex="-1" to hCaptcha badge links to remove them from tab order
    -------------------------------------------------------------- */

    (function () {
        function patchHCaptchaLinks() {
            var badge = document.getElementById('shop-hcaptcha-badge-container');
            if (!badge) return;

            var links = badge.querySelectorAll('.links a');
            links.forEach(function (link) {
            link.setAttribute('tabindex', '-1');
            });
        }

        document.addEventListener('DOMContentLoaded', patchHCaptchaLinks);

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (!(node instanceof HTMLElement)) return;

                if (node.id === 'shop-hcaptcha-badge-container' ||
                    node.querySelector('#shop-hcaptcha-badge-container')) {
                patchHCaptchaLinks();
                }
            });
        });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
    })();

    /* ==========================================================================
    = Homepage Accessibility Fixes 
    ========================================================================== */

    /* = Fix 64: Press quotes keyboard interaction
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
       var logos = document.querySelectorAll('.nss-press-quotes__logo[role="button"]');

       logos.forEach(function (logo) {
            function activate() {
                const ev = new MouseEvent('mouseenter', { 
                    bubbles: false,
                    cancelable: true,
                    composed: true,
                    view: window
                });
                logo.dispatchEvent(ev);
            }

            logo.addEventListener('focus', activate);

            logo.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault(); 
                    activate();
                }
            });    
        });
    });

    /* = Fix 65: Swiper slide role removal
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () { 
        document.querySelectorAll('li.swiper-slide[role="group"]').forEach(function (slide) { 
            slide.removeAttribute('role'); 
        }); 
    });

    /* ==========================================================================
    = Collections & Product Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 166: Yotpo tabindex adjustments
    -------------------------------------------------------------- */

    function fixYotpoContainer () { 
        document.querySelectorAll('.yotpo-bottomline[tabindex="0"]').forEach(el => { 
            el.removeAttribute('tabindex'); 
        });
    }

    function replaceYotpoReviewLink() {
        const links = document.querySelectorAll('.yotpo-bottomline a.text-m'); 
        links.forEach(a => { 
            const span = document.createElement('span'); 
            span.className = a.className; 
            span.textContent = a.textContent; 
            a.replaceWith(span); 
        }); 
    }

    /* = Fix 92: Yotpo aria-labels on prev/next arrow controls (subscribe page)
    -------------------------------------------------------------- */

    function fixYotpoNavLabels() { 
        const prev = document.querySelector('.yotpo-icon-left-arrow-light[role="button"]'); 
        const next = document.querySelector('.yotpo-icon-right-arrow-light[role="button"]'); 
        
        if (prev) prev.setAttribute('aria-label', 'Previous review'); 
        if (next) next.setAttribute('aria-label', 'Next review');
    }
    
    /* = Fix 92 end
    -------------------------------------------------------------- */

    /* = Fix 111: Yotpo summary aria adjustments (product page)
    -------------------------------------------------------------- */

    function fixYotpoSummary() { 
        document.querySelectorAll('.yotpo-paragraph-summary-content').forEach(el => { 
            el.removeAttribute('role');
            el.removeAttribute('tabindex'); 
            el.removeAttribute('aria-label'); 
        }); 
    }

    /* = Fix 111 end
    -------------------------------------------------------------- */

    /* = Fix 112: Yotpo summary button keyboard interaction (product page)
    -------------------------------------------------------------- */

    function fixYotpoSummaryButton() { 
        document.querySelectorAll('.yotpo-reviews-summary-button[role="button"]').forEach(el => { 
            el.addEventListener('keydown', e => { 
                if (e.code === 'Space' || e.key === ' ') { 
                    e.preventDefault(); 
                    el.click(); 
                } 
            }); 
        }); 
    }

    /* = Fix 112 end
    -------------------------------------------------------------- */

    /* = Fix 113: Yotpo popular topics heading level (product page)
    -------------------------------------------------------------- */

    function fixYotpoPopularTopicsHeading() { 
        document.querySelectorAll('.yotpo-smart-topics-headline').forEach(el => { 
            el.setAttribute('role', 'heading'); 
            el.setAttribute('aria-level', '4'); 
        }); 
    }

    /* = Fix 113 end
    -------------------------------------------------------------- */

    /* = Fix 115: Yotpo search button label (product page)
    -------------------------------------------------------------- */

    function fixYotpoSearchButtonLabel() {
        const observer = new MutationObserver((mutations, obs) => {
            const btn = document.querySelector('.yotpo-icon-button');
            if (!btn) return;

            btn.setAttribute('aria-label', 'Search reviews');

            obs.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Fix 115 end
    -------------------------------------------------------------- */

    /* = Fix 120: Yotpo show more button accessibility (product page)
    -------------------------------------------------------------- */

    function fixYotpoShowMoreAccessibility() {
        const observer = new MutationObserver(() => {
            const btn = document.querySelector('.yotpo-smart-topics-see-more-label');
            if (!btn) return;

            btn.setAttribute('aria-label', 'Show more review topics');

            btn.addEventListener('click', () => {
                const pressed = btn.getAttribute('aria-pressed') === 'true'; 
                btn.setAttribute('aria-label', pressed ? 'Show fewer review topics' : 'Show more review topics');
            });

            observer.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Fix 120 end
    -------------------------------------------------------------- */

    /* = Fix 121: Yotpo show more button focus (product page)
    -------------------------------------------------------------- */

    function fixYotpoShowMoreFocus() {
        const containerSelector = '.smart-topic-collection'; 
        const showMoreSelector = '.yotpo-smart-topics-see-more-label';

        const container = document.querySelector(containerSelector);
        if (!container) return;

        let previousCount = container.querySelectorAll('.yotpo-smart-topic-filter').length;

        document.addEventListener('click', (event) => {
            const btn = event.target.closest(showMoreSelector); 
            if (!btn) return;

            setTimeout(() => {
                const topics = container.querySelectorAll('.yotpo-smart-topic-filter');
                const newCount = topics.length;

                if (newCount > previousCount) {
                    const firstNewTopic = topics[previousCount];
                    if (firstNewTopic) firstNewTopic.focus();
                }

                previousCount = newCount;
            }, 300);
        });
    }

    /* = Fix 121 end
    -------------------------------------------------------------- */

    /* = Fix 122: Yotpo read more buttons descriptive labels (product page)
    -------------------------------------------------------------- */

    function fixYotpoReadMoreLabels() {
        const observer = new MutationObserver(() => {
            const reviews = document.querySelectorAll('.yotpo-reviews-item');

            reviews.forEach((review, index) => {
                const btn = review.querySelector('.yotpo-read-more');
                if (!btn) return;

                const reviewNumber = index + 1;
                const isExpanded = btn.getAttribute('aria-expanded') === 'true';

                const label = isExpanded ? `Read less of review ${reviewNumber}` : `Read more from review ${reviewNumber}`;

                btn.setAttribute('aria-label', label);
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Fix 122 end
    -------------------------------------------------------------- */

    /* = Fix 127: Yotpo upload instructions (product page)
    -------------------------------------------------------------- */

    function fixYotpoUploadInstructions() {
        const observer = new MutationObserver(() => {
            const uploadButton = document.querySelector('.yotpo-upload-label');
            const instructionNodes = document.querySelectorAll('.yotpo-new-input-message');

            if (!uploadButton || instructionNodes.length === 0) return;

            const instructions = instructionNodes[instructionNodes.length - 1];

            if (instructions.id !== 'yotpo-upload-instructions') { 
                instructions.id = 'yotpo-upload-instructions'; 
            }

            if (uploadButton.getAttribute('aria-describedby') !== 'yotpo-upload-instructions') { 
                uploadButton.setAttribute('aria-describedby', 'yotpo-upload-instructions'); 
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Fix 127 end
    -------------------------------------------------------------- */

    /* = Fix 128: Yotpo summary button aria-label (product page)
    -------------------------------------------------------------- */

    function fixYotpoSummaryButtonLabel() {
      const observer = new MutationObserver((mutations, obs) => {
          const btn = document.querySelector('.yotpo-reviews-summary-button');
          
          // Check if btn exists BEFORE trying to query it
          if (!btn) return;
          
          const textNode = btn.querySelector('.yotpo-reviews-summary-button-text');
   
          if (!textNode) return;
  
          const visibleText = textNode.textContent.trim();
          const correctLabel = `${visibleText} – view detailed reviews summary`;
  
          btn.setAttribute('aria-label', correctLabel);
  
          obs.disconnect();
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
  }

    /* = Fix 128 end
    -------------------------------------------------------------- */

    function fixYotpo() { 
        fixYotpoContainer(); 
        replaceYotpoReviewLink();
        fixYotpoNavLabels(); // Fix 92
        fixYotpoSummary(); // Fix 111
        fixYotpoSummaryButton(); // Fix 112
        fixYotpoPopularTopicsHeading(); // Fix 113
        fixYotpoSearchButtonLabel(); // Fix 115
        fixYotpoShowMoreAccessibility(); // Fix 120
        fixYotpoShowMoreFocus(); // Fix 121
        fixYotpoReadMoreLabels(); // Fix 122
        fixYotpoUploadInstructions(); // Fix 127
        fixYotpoSummaryButtonLabel(); // Fix 128
    }

    function waitForYotpo() {
        const yotpoEl = document.querySelector('.yotpo-bottomline');

        if (yotpoEl) {
            fixYotpo();

            const observer = new MutationObserver(() => { 
                fixYotpo(); 
            });

            observer.observe(document.body, { 
                childList: true, 
                subtree: true 
            });
        } else {
            setTimeout(waitForYotpo, 200);
        }
    }

    waitForYotpo();


    /* = Fixes 118 & 178: FAQ accordion accessibility enhancements
    -------------------------------------------------------------- */

    function fixFaqAccordionAccessibility() {
        const faqButtons = document.querySelectorAll('button[nss-faq-item]');

        faqButtons.forEach((btn, index) => {
            const triggerId = `faq-trigger-${index + 1}`;
            const panelId = `faq-panel-${index + 1}`;

            if (!btn.id) btn.id = triggerId;

            const panel = btn.nextElementSibling;
            if (!panel) return;

            panel.id = panelId;
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', triggerId);
            btn.setAttribute('aria-controls', panelId);
        });

        const syncStates = () => {
            faqButtons.forEach((btn) => {
                const isOpen = btn.classList.contains('nss-active');
                btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        };

        syncStates();

        const faqRoots = document.querySelectorAll('.nss-faqs-filter__faqs-items'); // Fix for the FAQs page

        faqRoots.forEach((root) => { 
            const observer = new MutationObserver(syncStates); 
            observer.observe(root, { 
                attributes: true, 
                subtree: true, 
                attributeFilter: ['class'] 
            }); 
        });
    }

    fixFaqAccordionAccessibility();

    /* = Fix 119: FAQ tabs accessibility enhancements
    -------------------------------------------------------------- */

    function fixFaqTabsAccessibility() {
        const tabs = document.querySelectorAll('button[nss-faqs-category]');
        if (!tabs.length) return;

        tabs.forEach((tab, index) => {
            const category = tab.getAttribute('nss-faqs-category'); 
            const tabId = `faq-tab-${category}`; 
            const panelId = `faq-panel-${category}`;

            tab.id = tabId;

            const isActive = tab.classList.contains('nss-active');
            tab.setAttribute('role', 'tab'); 
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false'); 
            tab.setAttribute('aria-controls', panelId);

            const panel = document.querySelector(`[nss-faqs-items="${category}"]`);
            if (panel) {
                panel.id = panelId;
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('aria-labelledby', tabId);
            }

            tab.addEventListener('click', () => {
                setTimeout(() => {
                    tabs.forEach((otherTab) => {
                        const active = otherTab.classList.contains('nss-active'); otherTab.setAttribute('aria-selected', active ? 'true' : 'false');
                    });
                }, 0);
            });
        });
    }

    fixFaqTabsAccessibility();

    /* ==========================================================================
    = Impact Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 200: Hero video alt text fix
    -------------------------------------------------------------- */

    function fixVideoFallbackAlt() {
        const observer = new MutationObserver((mutations, obs) => {
            const fallbackImages = document.querySelectorAll('video > img');

            if (!fallbackImages.length) return;

            fallbackImages.forEach(img => {
                if (!img.hasAttribute('alt')) { 
                    img.setAttribute('alt', ''); 
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    fixVideoFallbackAlt();

    function fixAccordionAccessibility() {
        const accordionItems = document.querySelectorAll('.nss-accordion-item');

        const applyAttributes = () => {
            accordionItems.forEach((item, index) => {
                const btn = item.querySelector('button'); 
                const panel = item.querySelector('.nss-accodion-item__text'); 
                if (!btn || !panel) return;

                const triggerId = btn.id || `accordion-trigger-${index + 1}`; 
                const panelId = panel.id || `accordion-panel-${index + 1}`;

                btn.id = triggerId; 
                panel.id = panelId;

                btn.setAttribute('aria-controls', panelId); 
                panel.setAttribute('role', 'region'); 
                panel.setAttribute('aria-labelledby', triggerId);

                const isOpen = item.classList.contains('nss-active'); 
                btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        };

        applyAttributes();

        accordionItems.forEach((item) => { 
            const btn = item.querySelector('button'); 
            if (!btn) return; 
            
            btn.addEventListener('click', () => { 
                requestAnimationFrame(() => { 
                    applyAttributes(); 
                }); 
            }); 
        });
    }

    fixAccordionAccessibility();

    /* ==========================================================================
    = FAQs Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 179: External FAQ links aria-label and rel attributes
    -------------------------------------------------------------- */

    document.querySelectorAll('nss-faqs-filter .nss-faqs-filter__faqs-items li > div a[target="_blank"]').forEach(link => { 
        const text = link.textContent.trim(); 
        link.setAttribute('aria-label', `${text}, opens in a new window`); 
        link.setAttribute('rel', 'noopener'); 
    });

    /* = Fixes 180 & 182: FAQ filter accessibility
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const dropdowns = document.querySelectorAll('[nss-faqs-filter-dropdown]');

        dropdowns.forEach((dropdown, index) => {
            const wrapper = dropdown.closest('.nss-faqs-filter__faqs-category-filter-wrapper-inner');
            if (!wrapper) return;

            const button = wrapper.querySelector('[nss-faqs-filter-button]');
            if (!button) return;

            const dropdownId = dropdown.id || `faq-filter-dropdown-${index + 1}`;
            dropdown.id = dropdownId;

            button.setAttribute('role', 'button');
            button.setAttribute('aria-controls', dropdownId);

            const syncState = () => {
                const isOpen = dropdown.classList.contains('nss-active');

                button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

                if (isOpen) {
                    dropdown.removeAttribute('hidden');
                    dropdown.setAttribute('aria-hidden', 'false');
                } else {
                    dropdown.setAttribute('hidden', '');
                    dropdown.setAttribute('aria-hidden', 'true');
                }
            };

            syncState();

            const observer = new MutationObserver(syncState);

            observer.observe(dropdown, {
                attributes: true,
                attributeFilter: ['class']
            });

            observer.observe(button, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    });

    /* ==========================================================================
    = Login, Reset Password & Create Account Pages Accessibility Fixes 
    ========================================================================== */

    /* = Fix 133: Disable native form validation and add custom validation
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const accountForms = document.querySelectorAll('form');

        accountForms.forEach(form => {
            form.setAttribute('novalidate', 'novalidate');

            const formType = form.querySelector('input[name="form_type"]');

            if (formType && formType.value === 'create_customer') { 
                console.log("Register handler attached"); 
                form.addEventListener('submit', handleRegisterValidation, true); 
                return;
            }

            if (formType && formType.value === 'customer_login') { 
                console.log("Login handler attached"); 
                form.addEventListener('submit', handleLoginValidation, true); 
                return; 
            }

            if (formType && formType.value === 'recover_customer_password') { 
                console.log("Recover handler attached"); 
                form.addEventListener('submit', handleRecoverValidation, true); 
                return; 
            }
        });
    });

    function handleLoginValidation(e) {
        console.log("Register validation fired");
        const form = e.target; 

        const email = form.querySelector('#customer-email, [name="customer[email]"]'); 
        const password = form.querySelector('#customer-password, [name="customer[password]"]'); 
        const emailError = form.querySelector('#customer-email-error, .customer-email-error'); 
        const passwordError = form.querySelector('#customer-password-error, .customer-password-error'); 

        let valid = true; 

        if (email && emailError) { 
            if (!email.value.trim()) { 
                valid = false; 
                emailError.textContent = "Enter your email address."; 
                emailError.hidden = false; 
                email.setAttribute('aria-invalid', 'true'); 
            } else if (!email.value.includes('@')) { 
                valid = false; 
                emailError.textContent = "Enter a valid email address."; 
                emailError.hidden = false; 
                email.setAttribute('aria-invalid', 'true'); 
            } else { 
                emailError.hidden = true; 
                email.setAttribute('aria-invalid', 'false'); 
            } 
        } 
        
        if (password && passwordError) { 
            if (!password.value.trim()) { 
                valid = false; 
                passwordError.textContent = "Enter the password."; 
                passwordError.hidden = false; 
                password.setAttribute('aria-invalid', 'true'); 
            } else {  
                passwordError.hidden = true; 
                password.setAttribute('aria-invalid', 'false'); 
            } 
        } 
        
        if (!valid) { 
            e.stopImmediatePropagation(); 
            e.preventDefault(); 
        } 
    }

    function handleRegisterValidation(e) {
        console.log("Register validation fired");
        const form = e.target;
 
        const email = form.querySelector('[name="customer[email]"]'); 
        const password = form.querySelector('[name="customer[password]"]'); 

        const emailError = form.querySelector('#register-email-error'); 
        const passwordError = form.querySelector('#register-password-error'); 

        let valid = true;

        if (email && emailError) { 
            if (!email.value.trim()) { 
                valid = false; 
                emailError.textContent = "Enter your email address."; 
                emailError.hidden = false; email.setAttribute('aria-invalid', 'true'); 
            } else if (!email.value.includes('@')) { 
                valid = false; 
                emailError.textContent = "Enter a valid email address."; 
                emailError.hidden = false; 
                email.setAttribute('aria-invalid', 'true'); 
            } else { 
                emailError.hidden = true; 
                email.setAttribute('aria-invalid', 'false'); 
            } 
        }

        if (password && passwordError) { 
            if (!password.value.trim()) { 
                valid = false; 
                passwordError.textContent = "Enter a password."; 
                passwordError.hidden = false; 
                password.setAttribute('aria-invalid', 'true'); 
            } else { 
                passwordError.hidden = true; 
                password.setAttribute('aria-invalid', 'false'); 
            } 
        }

        if (!valid) { 
            e.stopImmediatePropagation(); 
            e.preventDefault(); 
        }
    }

    function handleRecoverValidation(e) {
        console.log("Register validation fired"); 
        const form = e.target; 

        const email = form.querySelector('#RecoverEmail, [name="email"], [name="customer[email]"]');
        const emailError = form.querySelector('#recover-email-error, .recover-email-error'); 
        
        let valid = true; 

        if (email && emailError) { 
            if (!email.value.trim()) { 
                valid = false; 
                emailError.textContent = "Enter your email address."; 
                emailError.hidden = false; 
                email.setAttribute('aria-invalid', 'true'); 
            } else if (!email.value.includes('@')) { 
                valid = false; 
                emailError.textContent = "Enter a valid email address."; 
                emailError.hidden = false; 
                email.setAttribute('aria-invalid', 'true'); 
            } else { 
                emailError.hidden = true; 
                email.setAttribute('aria-invalid', 'false'); 
            } 
        } 
        
        if (!valid) { 
            e.stopImmediatePropagation(); 
            e.preventDefault(); 
        }
    }

    /* = Fix 135: Password visibility toggle aria-pressed attribute
    -------------------------------------------------------------- */

    document.addEventListener('click', function (e) { 
        const btn = e.target.closest('[nss-toggle-password-visibility]'); 
        if (!btn) return; 
        
        const current = btn.getAttribute('aria-pressed') === 'true'; 
        btn.setAttribute('aria-pressed', String(!current)); 
    });

    /* ==========================================================================
    = Contact Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 171: Password visibility toggle aria-pressed attribute
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const contactButton = document.querySelector('#contact_form .nss-button span .nss-icon-social-email');
        if (contactButton) {
            contactButton.setAttribute('aria-hidden', 'true');
            const title = contactButton.querySelector('title');
            if (title) title.remove();
        }
    });

    /* ==========================================================================
    = Accessibility Statement Page Accessibility Fixes 
    ========================================================================== */

    if (window.location.pathname === "/pages/accessibility-statement") {

        /* = Fix 170: Add indicator for external link
        -------------------------------------------------------------- */

        document.addEventListener('DOMContentLoaded', () => { 
            const link = document.querySelector('.nss-richtext a[href="https://www.w3.org/WAI/standards-guidelines/wcag/"][target="_blank"]'); 
            
            if (link) { 
                link.insertAdjacentHTML('beforeend', ' <span aria-hidden="true">↗</span><span class="sr-only">Opens in a new tab</span>'); 
            } 
        });
    }

    /* ==========================================================================
    = APPI Compliance Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 36: Abbreviation accessibility for screen readers
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const map = {
            VCDPA: 'V C D P A',
            CTDPA: 'C T D P A',
            PIPEDA: 'P I P E D A',
            LGPD: 'L G P D',
            GDPR: 'G D P R',
            CCPA: 'C C P A',
            CPRA: 'C P R A',
            CPA: 'C P A',
            UCPA: 'U C P A',
            APPI: 'A P P I'
        };

        const container = document.querySelector('#appi_page .text-center');
        if (!container) return;

        let html = container.innerHTML;

        Object.keys(map).forEach(abbrev => {
            const regex = new RegExp(`\\b${abbrev}\\b`, 'g');
            html = html.replace(
            regex,
            `<span aria-label="${map[abbrev]}">${abbrev}</span>`
            );
        });

        container.innerHTML = html;
    });

    /* ==========================================================================
    = CCPA Opt-Out Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 51: Fix colour contrast issue with the button arrow
        -------------------------------------------------------------- */

    if (window.location.pathname === "/pages/ccpa-opt-out") {
       document.addEventListener("DOMContentLoaded", function () {
           document.body.classList.add("nss-ccpa-opt-out");
       });
    }

    /* ==========================================================================
    = Coconut Grove Page Accessibility Fixes 
    ========================================================================== */

    if (window.location.pathname === "/pages/coconut_grove") {
        document.addEventListener("DOMContentLoaded", function () {

            /* = Fix 68: Add meaningful alt text for the Vita Coco logo on this page
            -------------------------------------------------------------- */

            const img = document.querySelector(".roblox-hero__logo-media img"); 
            if (img && !img.hasAttribute("alt")) { 
                img.setAttribute("alt", "Vita Coco logo"); 
            }

            /* = Fix 69: Ensure SVGs are ignored by screen readers
            -------------------------------------------------------------- */

            document.querySelectorAll(".nss-icon-arrow").forEach(svg => { 
                svg.removeAttribute("role"); 
                svg.removeAttribute("aria-labelledby"); 
                svg.setAttribute("aria-hidden", "true"); 
                svg.setAttribute("focusable", "false"); 
            });

            /* = Fix 71: Aria-labels for buttons
            -------------------------------------------------------------- */

            window.addEventListener('load', function () {
                document.querySelectorAll('a.nss-cta.nss-button[href*="Vita-Coco-The-Coconut-Grove"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Play the Vita Coco Roblox game');
                    }
                });

                document.querySelectorAll('div.roblox-logos-txt__text a[href*="Vita-Coco-The-Coconut-Grove"]').forEach(function (a) { 
                    if (!a.hasAttribute('aria-label')) { 
                        a.setAttribute('aria-label', 'Enter the Vita Coco Roblox game'); 
                    } 
                });

                document.querySelectorAll('a.nss-cta.nss-button[href*="/pages/impact"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Learn more about our impact');
                    }
                });

                document.querySelectorAll('a.nss-cta.nss-button[href="/products/coconut-water"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Shop Vita Coco Coconut Water');
                    }
                });

                document.querySelectorAll('a.nss-cta.nss-button[href="/products/extra-coconut"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Shop Vita Coco Extra Coconut');
                    }
                });
            });
        });
    }

    /* ==========================================================================
    = Subscribe Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 95: Keyboard focus on product sticky bar
    -------------------------------------------------------------- */

    document.addEventListener('focusin', (e) => { 
        const sticky = document.querySelector('.nss-buybox__sticky-atc'); 
        if (!sticky) return; 
        
        if (sticky.contains(e.target)) { 
            sticky.classList.add('nss-active'); 
        } 
    });

    if (window.location.pathname === '/pages/subscribe') {

        /* = Fix 100: Add aria-label for "Subscribe today" buttons
        -------------------------------------------------------------- */

        function addAriaLabels() {
            const buttons = document.querySelectorAll('.nss-button');
            buttons.forEach(btn => {
                const text = btn.textContent.trim();
                if (text.includes('Subscribe Today') && !btn.hasAttribute('aria-label')) {
                    btn.setAttribute('aria-label', 'Subscribe today - view purchase options');
                }
            });
        }

        addAriaLabels();

        const observer = new MutationObserver(() => {
            addAriaLabels();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        /* = Fix 104: Change incorrect h1 to h3
        -------------------------------------------------------------- */

        function fixBuyboxHeadings() {
            const badHeadings = document.querySelectorAll('.nss-buybox__heading h1.nss-h3');
            if (!badHeadings.length) return false;

            badHeadings.forEach(h1 => {
                const h3 = document.createElement('h3');
                h3.className = h1.className;
                h3.innerHTML = h1.innerHTML;
                h1.replaceWith(h3);
            });

            return true;
        }

        document.addEventListener('DOMContentLoaded', function () {
            if (fixBuyboxHeadings()) return;

            const observer = new MutationObserver(() => {
                if (fixBuyboxHeadings()) {
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    /* ==========================================================================
    = Multimedia Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 147: Add keyboard focus to newly loaded multimedia blocks
        -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const blocks = document.querySelectorAll('multimedia-block');

        blocks.forEach(block => {
            const grid = block.querySelector('.multimedia__grid');
            const loadMoreBtn = block.querySelector('.js-load-more');

            if (!grid || !loadMoreBtn) return;

            let previousCount = 0;
            let waiting = false;

            const observer = new MutationObserver(() => {
                if (!waiting) return;

                const cards = grid.querySelectorAll('.multimedia-card');

                if (cards.length > previousCount) {
                    const firstNew = cards[previousCount];

                    if (firstNew) {
                        const link = firstNew.querySelector('a');

                        if (link) {
                            link.focus();
                        } else {
                            firstNew.setAttribute('tabindex', '-1');
                            firstNew.focus();
                        }
                    }

                    waiting = false;
                }
            });

            observer.observe(grid, { childList: true, subtree: true });

            loadMoreBtn.addEventListener('click', () => {
                const cards = grid.querySelectorAll('.multimedia-card');
                previousCount = cards.length;
                waiting = true;
            });
        });
    });

    /* = Fix 148: Ensure no keyboard focus on hidden video controls & fix play button
        -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const videos = document.querySelectorAll('.multimedia-card__img--video');
        const updateVideoFocusState = video => { 
            const style = window.getComputedStyle(video); 
            const isHidden = style.opacity === '0' || style.visibility === 'hidden'; 

            if (isHidden) { 
                video.setAttribute('tabindex', '-1'); 
            } else { 
                video.removeAttribute('tabindex'); 
            } 
        }; 
        
        videos.forEach(video => updateVideoFocusState(video)); 
        
        const observer = new MutationObserver(() => { 
            videos.forEach(video => updateVideoFocusState(video)); 
        }); 
        
        observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });

        document.querySelectorAll('.multimedia-card__play').forEach(btn => { 
            btn.addEventListener('click', () => { 
                const card = btn.closest('.multimedia-card'); 
                const video = card.querySelector('.multimedia-card__img--video'); 
                if (!video) return; 
                video.style.opacity = '1'; 
                video.style.minHeight = ''; 
                video.setAttribute('controls', ''); 
                video.removeAttribute('tabindex'); 
                btn.style.display = 'none'; 
                video.play(); 
            }); 
        }); 
    });

    /* = Fix 153: Announce each current multimedia page
        -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const activeItem = document.querySelector('.multimedia__nav-item.is-active a');
        if (activeItem) {
            activeItem.setAttribute('aria-current', 'page');
        }
    });

    /* ==========================================================================
    = Butter Espresso Bliss Page Accessibility Fixes 
    ========================================================================== */

    if (window.location.pathname === '/blogs/recipes/buttered-espresso-bliss') {
        document.body.classList.add("nss-buttered-espresso-bliss");

        /* = Fix 234: Change recipe card headings from h2 to h3
        -------------------------------------------------------------- */

        document.querySelectorAll('h2.lsg-article-recipe-card__title').forEach(h2 => { 
            const h3 = document.createElement('h3'); 
            [...h2.attributes].forEach(a => h3.setAttribute(a.name, a.value)); 
            
            while (h2.firstChild) h3.appendChild(h2.firstChild); h2.replaceWith(h3); 
        });
    }

    /* ==========================================================================
    = Account Address Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 236: Add keyboard focus trap inside new address modal
        -------------------------------------------------------------- */

    const modalSelector = 'nss-cust-addresses .nss-cust-addresses__form[nss-form-modal-open="true"]';
    const firstSelector = 'fieldset input[type=checkbox]';
    const lastSelector = 'button[nss-form-modal-close]';

    function getOpenModals() {
        return document.querySelectorAll(modalSelector);
    }

    function getActiveModal() {
        const modals = getOpenModals();
        return Array.from(modals).find(m => m.contains(document.activeElement)) || modals[0] || null;
    }

    function getFirst(modal) {
        return modal.querySelector(firstSelector);
    }

    function getLast(modal) {
        return modal.querySelector(lastSelector);
    }

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;

        const modal = getActiveModal();
        if (!modal) return;
        if (!modal.contains(document.activeElement)) return;

        const first = getFirst(modal);
        const last = getLast(modal);
        if (!first || !last) return;

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
            return;
        }

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
            return;
        }
    });

    const addressModalObserver = new MutationObserver(() => {
    const modals = getOpenModals();
    modals.forEach(modal => {
        const first = getFirst(modal);
        if (first) setTimeout(() => first.focus(), 0);
    });
    });

    addressModalObserver.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['nss-form-modal-open']
    });
})();